import api from "../../../../lib/api";
import { IEditVasRatePayload, IVasRateCreate, IVasRateListSearch } from "../../../../types/master/vasRateInterface";

export const createVasRateApi = async (data: IVasRateCreate) => {
  return await api.post("/vas-rate-basis/", data);
};

export const getVasRateListApi = async (data: IVasRateListSearch) => {
  return await api.get(`/vas-rate-basis/${data.page}/${data?.pageLimit ?? 10}`, {
    params: {
      search: data?.search ?? "",
    },
  });
};

export const getVasRateDataByIdApi = async (id: number | string) => {
  return await api.get(`/vas-rate-basis/id/${id}`);
};

export const editVasRateDataByIdApi = async (payload: IEditVasRatePayload) => {
  return await api.put(`/vas-rate-basis/id/${payload.id}`, payload.data);
};
